import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { API_BASE } from "../config";
export default function PowerDevices() {
  const [devices, setDevices] = useState([]);
  const [editingDevice, setEditingDevice] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [newDevice, setNewDevice] = useState({
    name: "",
    reader_id: "",
    location: "",
    status: "off",
    deskripsi: "",
  });
  const customStyles = {
    headCells: {
      style: {
        justifyContent: "center", // center header
        textAlign: "center",
        fontWeight: "bold",       // bold text
        fontSize: "16px",   
      },
    },
    cells: {
      style: {
        justifyContent: "center", // center isi cell
        textAlign: "center",
      },
    },
  };
  
  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = () => {
    fetch(`${API_BASE}/api/power_devices_lokasi`)
      .then((res) => res.json())
      .then((data) => setDevices(data))
      .catch((err) => console.error("❌ Error fetch devices:", err));
  };

  const handleSave = (device) => {
    fetch(`${API_BASE}/api/power_devices/${device.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(device),
    })
      .then((res) => res.json().then((data) => ({ status: res.status, data })))
      .then(({ status, data }) => {
        if (status >= 400) throw new Error(data.error);
        setDevices((prev) =>
          prev.map((d) => (d.id === device.id ? { ...d, ...device } : d))
        );
        setEditingDevice(null);
        Swal.fire("Berhasil", `Device ${device.name} diperbarui`, "success");
      })
      .catch((err) => {
        console.error("❌ Gagal update device:", err);
        Swal.fire("Error", err.message || "Gagal update device", "error");
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Hapus device?",
      text: "Device akan dihapus permanen",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${API_BASE}/api/power_devices/${id}`, {
          method: "DELETE",
        })
          .then((res) => res.json())
          .then(() => {
            setDevices((prev) => prev.filter((d) => d.id !== id));
            Swal.fire("Terhapus!", "Device berhasil dihapus", "success");
          })
          .catch((err) => {
            console.error("❌ Gagal hapus device:", err);
            Swal.fire("Error", "Gagal hapus device", "error");
          });
      }
    });
  };

  const handleAddDevice = () => {
    fetch(`${API_BASE}/api/power_devices`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newDevice),
    })
      .then((res) => res.json().then((data) => ({ status: res.status, data })))
      .then(({ status, data }) => {
        if (status >= 400) throw new Error(data.error);
        setDevices((prev) => [...prev, data]);
        setShowModal(false);
        setNewDevice({ name: "", reader_id: "", location: "", status: "off", deskripsi: "" });
        Swal.fire("Berhasil", `Device ${data.name} ditambahkan`, "success");
      })
      .catch((err) => {
        console.error("❌ Gagal tambah device:", err);
        Swal.fire("Error", err.message || "Gagal tambah device", "error");
      });
  };

  const filteredDevices = devices.filter(
    (d) =>
      d.name.toLowerCase().includes(searchText.toLowerCase()) ||
      d.reader_id.toLowerCase().includes(searchText.toLowerCase()) ||
      d.location.toLowerCase().includes(searchText.toLowerCase()) ||
      d.deskripsi.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      name: "Switch",
      cell: (row) =>
        editingDevice?.id === row.id ? (
          <input
            type="text"
            value={editingDevice.name}
            onChange={(e) =>
              setEditingDevice({ ...editingDevice, name: e.target.value })
            }
            className="border p-1 rounded w-28 text-center"
          />
        ) : (
          <span className="text-center w-full block">{row.name}</span>
        ),
    },
    {
      name: "RFID Reader",
      cell: (row) =>
        editingDevice?.id === row.id ? (
          <input
            type="text"
            value={editingDevice.reader_id}
            onChange={(e) =>
              setEditingDevice({ ...editingDevice, reader_id: e.target.value })
            }
            className="border p-1 rounded w-28 text-center"
          />
        ) : (
          <span className="text-center w-full block">{row.reader_id}</span>
        ),
    },
    {
      name: "Location",
      cell: (row) =>
        editingDevice?.id === row.id ? (
          <input
            type="text"
            value={editingDevice.location}
            onChange={(e) =>
              setEditingDevice({ ...editingDevice, location: e.target.value })
            }
            className="border p-1 rounded w-40 text-center"
          />
        ) : (
          <span className="text-center w-full block">{row.location}</span>
        ),
    },
    {
      name: "Deskripsi",
      cell: (row) =>
        editingDevice?.id === row.id ? (
          <input
            type="text"
            value={editingDevice.deskripsi || ""}
            onChange={(e) =>
              setEditingDevice({ ...editingDevice, deskripsi: e.target.value })
            }
            className="border p-1 rounded w-64 text-center"
          />
        ) : (
          <span className="text-center w-full block">{row.deskripsi || ""}</span>
        ),
    },
    {
      name: "Status",
      cell: (row) =>
        editingDevice?.id === row.id ? (
          <select
            value={editingDevice.status}
            onChange={(e) =>
              setEditingDevice({ ...editingDevice, status: e.target.value })
            }
            className="border p-1 rounded w-20 text-center"
          >
            <option value="on">ON</option>
            <option value="off">OFF</option>
          </select>
        ) : (
          <span
            className={`px-3 py-1 rounded-lg text-white text-sm ${
              row.status?.toLowerCase() === "on" ? "bg-green-500" : "bg-gray-400"
            }`}
          >
            <span className="text-center w-full block">{row.status.toUpperCase()}</span>
          </span>
        ),
    },
    {
      name: "Action",
      cell: (row) =>
        editingDevice?.id === row.id ? (
          <div className="flex gap-2 justify-center">
            <button
              onClick={() => handleSave(editingDevice)}
              className="bg-green-500 text-white px-3 py-1 rounded"
            >
              Save
            </button>
            <button
              onClick={() => setEditingDevice(null)}
              className="bg-gray-400 text-white px-3 py-1 rounded"
            >
              Cancel
            </button>
          </div>
        ) : (
          <div className="flex gap-2 justify-center">
            <button
              onClick={() => setEditingDevice(row)}
              className="bg-blue-500 text-white px-3 py-1 rounded"
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(row.id)}
              className="bg-red-500 text-white px-3 py-1 rounded"
            >
              Delete
            </button>
          </div>
        ),
    },
  ];

  return (
    <div className="p-2">
      <h2 className="text-2xl font-bold mb-4 text-center">Manage Devices</h2>

      <div className="mb-4 flex gap-2">
  <input
    type="text"
    placeholder="🔍 Search Switch, Reader ID, Location, Deskripsi..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    className="border px-6 py-2 rounded flex-grow"
  />
  <button
    onClick={() => setShowModal(true)}
    className="px-4 py-2 bg-green-500 text-white rounded"
  >
    Add Device
  </button>
</div>


      <DataTable
        columns={columns}
        data={filteredDevices}
        pagination
        highlightOnHover
        responsive
        customStyles={customStyles}
      />

      {/* Modal Add Device */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-96">
            <h3 className="text-lg font-bold mb-4">Add New Device</h3>
            <input
              type="text"
              placeholder="Switch Name"
              value={newDevice.name}
              onChange={(e) =>
                setNewDevice({ ...newDevice, name: e.target.value })
              }
              className="border p-2 w-full mb-2 rounded"
            />
            <input
              type="text"
              placeholder="RFID Reader (kode)"
              value={newDevice.reader_id}
              onChange={(e) =>
                setNewDevice({ ...newDevice, reader_id: e.target.value })
              }
              className="border p-2 w-full mb-2 rounded"
            />
            <input
              type="text"
              placeholder="Location Name"
              value={newDevice.location}
              onChange={(e) =>
                setNewDevice({ ...newDevice, location: e.target.value })
              }
              className="border p-2 w-full mb-2 rounded"
            />
            <input
              type="text"
              placeholder="Deskripsi"
              value={newDevice.deskripsi}
              onChange={(e) =>
                setNewDevice({ ...newDevice, deskripsi: e.target.value })
              }
              className="border p-2 w-full mb-2 rounded"
            />
            <select
              value={newDevice.status}
              onChange={(e) =>
                setNewDevice({ ...newDevice, status: e.target.value })
              }
              className="border p-2 w-full mb-4 rounded"
            >
              <option value="on">ON</option>
              <option value="off">OFF</option>
            </select>
            <div className="flex justify-end gap-2">
              <button
                onClick={handleAddDevice}
                className="bg-green-500 text-white px-4 py-2 rounded"
              >
                Save
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-400 text-white px-4 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
